
import { defineComponent, ref, PropType } from 'vue';
import { ILogisticsSelectLogisticsNameRes } from '@/api/system-config/type.d';
import { addLogistics, updateLogistics } from '@/api/system-config/index';

export default defineComponent({
  name: 'logistics-info-dialog',
  props: {
    logisticsDialogVisible: {
      type: Boolean,
      default: true,
    },
    rowItem: {
      type: Object as PropType<ILogisticsSelectLogisticsNameRes>,
      default: () => {},
    },
    orderCode: {
      type: String,
      default: '',
    },
    logisticsType: {
      type: String,
      default: '',
    },
  },
  emits: ['update:logisticsDialogVisible', 'uploadList'],
  components: {
  },
  setup(props, { emit }) {
    // 物流项
    const choosedItem = ref<ILogisticsSelectLogisticsNameRes>(
      {
        parentId: '',
        name: '',
        logisticsId: '',
      },
    );
    // 物流名称-一级
    const firstName = ref<string>('');
    // 初始化数据
    const handleOpen = () => {
      choosedItem.value = {
        parentId: '',
        name: '',
        logisticsId: '',
      };

      if (['addChild', 'edit'].includes(props.logisticsType)) {
        choosedItem.value = JSON.parse(JSON.stringify(props.rowItem));
      }
      if (['addChild'].includes(props.logisticsType)) {
        firstName.value = JSON.parse(JSON.stringify(choosedItem.value.name));
        choosedItem.value.name = '';
      }
    };

    const refForm = ref(null);
    // 取消
    const handleCancel = () => {
      (refForm.value as any).resetFields();
      emit('update:logisticsDialogVisible', false);
    };
    // 确定
    const confirmUpdate = async () => {
      try {
        await (refForm.value as any).validate();

        const {
          name,
          logisticsId,
        } = choosedItem.value;
        const params: any = {
          name,
        };
        if (props.logisticsType === 'edit') {
          params.logisticsId = logisticsId;
          await updateLogistics(params);
        }
        if (props.logisticsType === 'add') {
          await addLogistics(params);
        }

        if (props.logisticsType === 'addChild') {
          params.parentId = logisticsId;
          await addLogistics(params);
        }

        emit('update:logisticsDialogVisible', false);
        emit('uploadList');
      } catch (error) {
        console.log(error);
      }
    };

    return {
      handleCancel,
      choosedItem,
      handleOpen,
      confirmUpdate,
      firstName,
      refForm,
      rules: {
        name: [
          {
            required: true,
            message: '物流名称不能为空',
          },
        ],
      },
    };
  },
});
